"use strict";
// Copyright (c) 2021 by Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContainer = exports.containerProps = void 0;
const composition_api_1 = require("@vue/composition-api");
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
exports.containerProps = {
    columns: {
        type: Number,
        required: true
    },
    component: {
        type: [Function, Object],
        required: false
    },
    containers: {
        type: Object,
        required: true
    },
    controls: {
        type: Object,
        required: true
    },
    definition: {
        type: Object,
        required: true
    },
    elementProps: {
        type: Object,
        required: false,
        default: () => ({})
    },
    index: {
        type: Number,
        required: true
    },
    innerClass: {
        type: String,
        required: false,
        default: null
    },
    showControls: {
        type: Boolean,
        required: false,
        default: false
    }
};
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
exports.useContainer = (props, ctx) => {
    const gridTemplate = composition_api_1.computed(() => {
        // TODO: Add option to change container columns.
        // if (true) {
        //   return null
        // }
        // return `#${props.definition.container}.builder__container-inner { grid-template-columns: repeat(${props.columns}, minmax(0, 1fr)); }`
        return null;
    });
    const resolvedComponent = composition_api_1.computed(() => {
        return typeof props.component !== 'undefined' ? props.component : 'div';
    });
    const resolvedContent = composition_api_1.computed(() => {
        if (typeof resolvedComponent.value === 'string') {
            return null;
        }
        if (!(props.definition.container in props.containers)) {
            throw new Error(`(Builder) There's no container data provided for [${props.definition.container}]`);
        }
        return props.containers[props.definition.container];
    });
    function clone() {
        ctx.emit('clone', props.definition, resolvedContent.value);
    }
    function triggerEvent(name) {
        ctx.emit(name, { type: name, container: props.definition.container, index: props.index });
    }
    return { clone, gridTemplate, resolvedComponent, resolvedContent, triggerEvent };
};
//# sourceMappingURL=Container.hooks.js.map